<template>
  <div>
    <div className="flex relative">
      <router-view name="sidebar" v-if="haveSidebar()" />
      <div :class="sidebarClass">
        <router-view name="header" v-if="haveHeader()" />
        <div :class="{ 'mb-4': !matchedAnnotations() }" id="main">
          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useLayoutStore } from '@/store/useLayoutStore';
import { useRoute } from 'vue-router';
import { computed } from 'vue';

const { isSidebarExpanded } = storeToRefs(useLayoutStore());

const route = useRoute();

const sidebarClass = computed(() => {
  const classes = ['w-full', 'sm:flex-grow'];
  if (matchedAnnotations()) {
    return classes.join(' ');
  }

  // add padding to the main content except for annotations
  classes.push('sm:px-6');
  if (!haveSidebar()) {
    return classes.join(' ');
  }

  classes.push(isSidebarExpanded.value ? 'sm:ml-72' : 'sm:ml-24');
  return classes.join(' ');
});

const haveSidebar = (): boolean => route.matched.some(route => route.components && !!route.components.sidebar);
const haveHeader = (): boolean => route.matched.some(route => route.components && !!route.components.header);

// we want to render annotations full screen without padding or margin that causes scroll
const matchedAnnotations = (): boolean => route.matched.some(route => route.name === 'annotations');
</script>
